import React, { useState } from "react";
import { Search } from "lucide-react";
import { PageShell, Eyebrow } from "../components/Layout";
import { GLOSSARY } from "../data/mock";

const CATS = ["All", ...Array.from(new Set(GLOSSARY.map((g) => g.cat)))];

const Glossary = () => {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("All");
  const list = GLOSSARY.filter((g) => (cat === "All" || g.cat === cat) && (g.term + g.def).toLowerCase().includes(q.toLowerCase()));

  return (
    <PageShell>
      <section className="hero-grid border-b border-neutral-200">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8 pt-16 pb-12">
          <Eyebrow>Live · updated from trending searches</Eyebrow>
          <h1 className="font-heading text-5xl lg:text-[60px] font-bold tracking-tight text-ink leading-[1.02]">The Risk Glossary</h1>
          <p className="mt-5 text-[16px] text-ink/60 max-w-2xl leading-relaxed">300+ curated definitions across ERM, cyber, privacy, AML/CTF, ESG and emerging risk — tuned to Australian regulatory vocabulary.</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <div className="relative w-full sm:w-96">
              <Search size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-neutral-400" />
              <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search a term…" data-testid="glossary-search-input"
                className="w-full border border-neutral-300 rounded-md pl-10 pr-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-accent bg-white" />
            </div>
            <div className="flex flex-wrap gap-2">
              {CATS.map((c) => (
                <button key={c} onClick={() => setCat(c)} data-testid={`glossary-filter-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className={`font-mono text-[11.5px] px-3 py-1.5 rounded-sm border transition-colors duration-150 ${cat === c ? "bg-ink text-white border-ink" : "border-neutral-300 text-ink/60 hover:border-ink"}`}>{c}</button>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="py-14">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8">
          <p className="font-mono text-[11px] text-neutral-400 tracking-wider mb-6">{list.length} TERMS</p>
          {list.length === 0 ? (
            <p className="text-ink/50 text-sm" data-testid="glossary-empty">No terms match your search. Try a broader query.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {list.map((g) => (
                <div key={g.slug} data-testid={`glossary-term-${g.slug}`} className="bg-white border border-neutral-200 rounded-lg p-6 hover:border-accent/40 hover:-translate-y-1 transition-[border-color,transform] duration-200">
                  <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-accent">{g.cat}</span>
                  <h3 className="font-heading text-[17px] font-bold text-ink mt-2.5">{g.term}</h3>
                  <p className="text-[13px] text-ink/60 leading-relaxed mt-2.5">{g.def}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </PageShell>
  );
};

export default Glossary;
